import {PDFDocument} from 'pdf-lib'

type CustomerDocument = {path?: string | null}

/** Append customer PDF attachments after the generated VOS PDF (pdf-lib used only for merge). */
export async function mergeVosPdfWithCustomerDocuments(
  vosPdfBytes: ArrayBuffer,
  customerDocuments: CustomerDocument[],
  appBaseUrl: string | undefined
): Promise<Blob> {
  const mergedPdf = await PDFDocument.create()
  const vosPdf = await PDFDocument.load(vosPdfBytes)
  const vosPages = await mergedPdf.copyPages(vosPdf, vosPdf.getPageIndices())
  vosPages.forEach((page) => mergedPdf.addPage(page))

  for (const doc of customerDocuments) {
    if (!doc.path) continue
    try {
      const fileUrl = `${appBaseUrl ?? ''}/${doc.path}`.replace(/([^:]\/)\/+/g, '$1')
      const docResponse = await fetch(fileUrl)
      if (!docResponse.ok) continue
      const docArrayBuffer = await docResponse.arrayBuffer()
      const docPdf = await PDFDocument.load(docArrayBuffer)
      const docPages = await mergedPdf.copyPages(docPdf, docPdf.getPageIndices())
      docPages.forEach((page) => mergedPdf.addPage(page))
    } catch (error) {
      console.error(`Error loading customer document ${doc.path}:`, error)
    }
  }

  const mergedBytes = await mergedPdf.save()
  return new Blob([mergedBytes], {type: 'application/pdf'})
}

export function downloadPdfBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = fileName.endsWith('.pdf') ? fileName : `${fileName}.pdf`
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  URL.revokeObjectURL(url)
}
